'use strict';

class SuperSystemSettingsController {
    constructor($timeout, SSUtilService, SSUserService, SSHttpService, OTPService, SSAlertService, SSConfirmationService) {
        const self = this;

        self.$timeout = $timeout;
        self.SSUtilService = SSUtilService;
        self.SSUserService = SSUserService;
        self.SSHttpService = SSHttpService;
        self.OTPService = OTPService;
        self.SSAlertService = SSAlertService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;

        self.SYSTEM_SETTINGS_SMS_SERVICE = SHOWSUITE.SYSTEM_SETTINGS_SMS_SERVICE;
        self.SYSTEM_SETTINGS_ENQUIRY_EMAIL = SHOWSUITE.SYSTEM_SETTINGS_ENQUIRY_EMAIL;
        self.LEAD_COMMISSION_SETTINGS = SHOWSUITE.LEAD_COMMISSION_SETTINGS;

        self.VALUE_TYPE_PERCENTAGE = SHOWSUITE.VALUE_TYPE_PERCENTAGE;
        self.VALUE_TYPE_AMOUNT = SHOWSUITE.VALUE_TYPE_AMOUNT;

        // WEB-4732: no requests without the view key (the settings list answers 403004).
        if (self.canView()) {
            self.init();
        }
    }

    // ---- Permissions (WEB-4732, keys from WEB-4725; the main super user passes all) ----

    /** @returns {boolean} May open the page and see the settings. */
    canView() {
        return this.SSUserService.isSuper() && this.SSUserService.hasPermission('SS_SYSTEM_SETTINGS_VIEW');
    }

    /**
     * @returns {boolean} May add a setting and edit one, including the SMS, Enquiry Email and
     *                    Lead Commission cards (they save through the same endpoint).
     */
    canEdit() {
        return this.SSUserService.hasPermission('SS_SYSTEM_SETTINGS_EDIT');
    }

    /** @returns {boolean} May delete a setting. */
    canDelete() {
        return this.SSUserService.hasPermission('SS_SYSTEM_SETTINGS_DELETE');
    }

    init() {
        const self = this;

        self.system_settings = [];
        self.sms_settings = {};
        self.properties = [];

        self.VALUE_TYPES = [
            {id: self.VALUE_TYPE_PERCENTAGE, name: 'Percentage'},
            {id: self.VALUE_TYPE_AMOUNT, name: 'Amount'}
        ];

        self.AMPS = [];

        self.getAMPS();
        self.getAllProperties();
        self.getSystemSettings();
    }

    getSystemSettings(){
        let self = this;

        let url = 'sec/super/system-settings';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.system_settings){

                // Get 'sms_settings'
                self.sms_settings = self.getSetting(response.data.system_settings, self.SYSTEM_SETTINGS_SMS_SERVICE);
                // Remove 'sms_settings' from original list
                self.system_settings = $.grep(response.data.system_settings, function(obj){
                    return obj.name != self.SYSTEM_SETTINGS_SMS_SERVICE;
                });

                // Get 'enquiry_email_settings'
                self.enquiry_email_settings = self.getSetting(response.data.system_settings, self.SYSTEM_SETTINGS_ENQUIRY_EMAIL);
                // Remove 'enquiry_email_settings' from original list
                self.system_settings = $.grep(response.data.system_settings, function(obj){
                    return obj.name != self.SYSTEM_SETTINGS_ENQUIRY_EMAIL;
                });

                // Get 'lead_commission_settings'
                self.lead_commission_settings = self.getSetting(response.data.system_settings, self.LEAD_COMMISSION_SETTINGS);
                // Remove 'lead_commission_settings' from original list
                self.system_settings = $.grep(response.data.system_settings, function(obj){
                    return obj.name != self.LEAD_COMMISSION_SETTINGS;
                });
            }

            if(!self.sms_settings){
                // Set default sms settings
                self.sms_settings = {name: self.SYSTEM_SETTINGS_SMS_SERVICE, value: {service_name: 'none'}};
            }

            if(!self.enquiry_email_settings){
                // Set default enquiry email settings
                self.enquiry_email_settings = {name: self.SYSTEM_SETTINGS_ENQUIRY_EMAIL, value: {enabled: 'false', emails:''}};
            }

            if(!self.lead_commission_settings){
                self.lead_commission_settings = {
                    name: self.LEAD_COMMISSION_SETTINGS,
                    value: {
                        showsuite_lead_commission_share: [
                            {type: self.VALUE_TYPE_PERCENTAGE, value: 25},
                        ],
                        amp_lead_commission_share: [
                            {type: self.VALUE_TYPE_PERCENTAGE, value: 25},
                        ]
                    }
                };
            }

        });
    }

    getAllProperties() {
        const self = this;

        let url = 'properties/customized';
        let params = {
            property_selected_fields: 'id,name,named_id',
            offset: 0,
            limit: 9999
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data.properties) {
                self.properties = response.data.properties;
            }
        });
    }

    getAMPS(){
        const self = this;

        let url = "sec/super/amps";
        let params = {
            response_type: 1
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data.amps) {
                self.AMPS = response.data.amps;
            }
        });
    }

    editSmsSettings(editMode){
        const self = this;

        self.systemSettingParams = {};
        self.systemSettingErrors = {};

        if(editMode){
            self.systemSettingParams = angular.copy(self.sms_settings);
        }

        self.smsSettingsEditMode = editMode;
    }

    editEnquiryEmailSettings(editMode){
        const self = this;

        self.systemSettingParams = {};
        self.systemSettingErrors = {};

        if(editMode){
            self.systemSettingParams = angular.copy(self.enquiry_email_settings);
        }

        self.enquiryEmailSettingsEditMode = editMode;
    }

    editLeadCommissionSettings(editMode){
        const self = this;

        self.leadCommissionSettingParams = {};
        self.leadCommissionSettingErrors = {};

        if(editMode){
            self.leadCommissionSettingParams = angular.copy(self.lead_commission_settings);
        }

        self.leadCommissionSettingsEditMode = editMode;
        self.updateSelection();
    }

    updateSystemSetting(setting){
        const self = this;

        self.systemSettingParams = {};
        self.systemSettingErrors = {};

        if(setting){
            self.systemSettingParams = angular.copy(setting);
        }

        $('#updateSystemSettingsModal').modal('show');
    }

    saveSystemSetting(validate = true, settingParams = null){
        const self = this;

        if(validate && !self.isValidInput()){
            return;
        }

        let url = 'sec/super/system-settings';
        
        let params = settingParams? angular.copy(settingParams) : angular.copy(self.systemSettingParams);
        
        try{
            params.value = JSON.stringify(params.value);
        }
        catch(ex){
            console.log();
        }

        let handleResponse = function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'Settings updated successfully.');
            self.getSystemSettings();
            self.smsSettingsEditMode = false;
            self.leadCommissionSettingsEditMode = false;
            self.enquiryEmailSettingsEditMode = false;
        };

        loading(true);
        if (params.id) {
            url += '/' + params.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }

    saveCommissionSetting(settingParams){
        const self = this;

        if(settingParams){
            if(self.isValidCommissionInput('showsuite_lead_commission_share') 
                && self.isValidCommissionInput('amp_lead_commission_share')){

                self.saveSystemSetting(false, settingParams);
            }
        }
    }

    deleteSystemSetting(setting){
        const self = this;

        if(!setting){
            return;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you would like to delete this system setting?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function() {
                self._deleteSystemSetting(setting);
            }
        );
    }

    _deleteSystemSetting(setting){
        const self = this;

        let url = 'sec/super/system-settings/'+ setting.id +'/delete';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'System setting has been deleted successfully');
            self.getSystemSettings();
        });
    }

    addCommessionSettingRow(commission_type){
        const self = this;

        if(!commission_type){
            return;
        }

        if(commission_type == 'showsuite_lead_commission_share')
        {
            self.leadCommissionSettingParams.value[commission_type].push({property_id: 0, type: self.VALUE_TYPE_PERCENTAGE, value: 0});
        }
        else if(commission_type == 'amp_lead_commission_share')
        {
            self.leadCommissionSettingParams.value[commission_type].push(
                {property_id: 0, amp_id: 0, type: self.VALUE_TYPE_PERCENTAGE, value: 0});
        }

        self.updateSelection();
    }

    removeCommessionSettingRow(commission_type){
        const self = this;

        // It should have at least one record
        if(!commission_type || self.leadCommissionSettingParams.value[commission_type].length == 1){
            return;
        }

        self.leadCommissionSettingParams.value[commission_type].pop();
        self.updateSelection();
    }

    isValidInput(){
        const self = this;

        self.systemSettingErrors = {};
        let isValid = true;

        if(!self.systemSettingParams.name){
            self.systemSettingErrors.name = "Please enter setting name";
            isValid = false;
        }
        if(!self.systemSettingParams.value){
            self.systemSettingErrors.value = "Please enter the value";
            isValid = false;
        }
        else{
            try {
                // Check if string is valid json
                $.parseJSON(self.systemSettingParams.value);
            }
            catch (ex) {
                self.systemSettingErrors.value = "Please enter valid JSON string";
                isValid = false;
                console.log(ex);
            }
        }

        return isValid;
    }

    isValidCommissionInput(commission_type){
        const self = this;

        self.commissionSettingErrors = {};
        self.commissionSettingErrors[commission_type] = {};

        let isValid = true;
        
        $.each(self.leadCommissionSettingParams.value[commission_type], function(index, obj){
            self.commissionSettingErrors[commission_type][index] = {};
            if(!obj.type){
                self.commissionSettingErrors[commission_type][index].type = "Please select type";
                isValid = false;
            }
            if(!obj.value){
                self.commissionSettingErrors[commission_type][index].value = "Please enter value";
                isValid = false;
            }
            if(index > 0){
                if(!obj.property_id){
                    self.commissionSettingErrors[commission_type][index].property_id = "Please select a project";
                    isValid = false;
                }
                // AMP is optional
                // if(commission_type == 'amp_lead_commission_share'){
                //     if(!obj.amp_id){
                //         self.commissionSettingErrors[commission_type][index].amp_id = "Please select AMP";
                //         isValid = false;
                //     }
                // }
            }
        });

        return isValid;
    }

    getSetting(settings, setting_name){
        const self = this;

        if(!(settings || setting_name)){
            return null;
        }

        let setting = {};

        try{
            setting = settings.find(x => x.name == setting_name);

            if(setting && setting.value){
                if(typeof setting.value == "string"){
                    setting.value = JSON.parse(setting.value);
                }
                else{
                    setting.value = setting.value;
                }
            }
        }
        catch(ex){
            console.log(ex);
        }

        return setting;
    }

    getValueTypeName(type){
        const self = this;

        let name = '--';

        if(!type){
            return name;
        }

        let value_type = self.VALUE_TYPES.find(x => x.id == type);
        if(value_type){
            name = value_type.name;
        }

        return name;
    }

    getProjectName(property_id){
        const self = this;

        let name = '--';

        if(!property_id || self.properties.length == 0){
            return name;
        }

        let property = self.properties.find(x => x.id == property_id);
        if(property){
            name = property.name;
        }

        return name;
    }

    getAMPName(amp_id){
        const self = this;

        let name = '--';

        if(!amp_id || self.AMPS.length == 0){
            return name;
        }

        let amp = self.AMPS.find(x => x.id == amp_id);
        if(amp){
            name = amp.name;
        }

        return name;
    }

    updateSelection(){
        const self = this;

        self.$timeout(function() { $("select.commission-select").niceSelect('update'); });
    }

    hideModals(){
        const self = this;

        if ($('#updateSystemSettingsModal').is(':visible')) $('#updateSystemSettingsModal').modal('hide');
    }

}

SuperSystemSettingsController.$inject = ['$timeout', 'SSUtilService', 'SSUserService', 'SSHttpService','OTPService', 'SSAlertService', 'SSConfirmationService'];
app.controller('SuperSystemSettingsController', SuperSystemSettingsController);
